module.exports = __webpack_public_path__ + "img/atlaslist1img3.77cd793f.jpg";